import {
  Banner,
  BlockStack,
  Button,
  Card,
  Layout,
  Select,
  Text
} from '@shopify/polaris'
import { useTranslation } from 'react-i18next'
import { useState } from 'react'

import { SEGMENTS } from '../../../../constants/segmentation'
import { areFeaturesEnabled } from '../../../../utils/features'
import { FEATURES } from '../../../../constants/features'
import { usePricing } from '../../../../components/PricingModal'

export default function Segmentations({ dashboardData, form, pricing }) {
  const { t } = useTranslation()
  const featureEnabled = areFeaturesEnabled([FEATURES.SEGMENTS], dashboardData)

  return (
      <Card id="segmentation">
        <BlockStack gap={'300'}>
          <Text as="strong"> {t(
              'Section.Edit.Sections.SegmentationConfig.FormFields.Selection.label',
            )}
          </Text>
          {!featureEnabled && (
            <Banner>
              <BlockStack gap={'200'}>
                <p>
                  {t('Features.notAvailableInPlanText', {
                    feature: t('Features.labels.segments'),
                    cta: (
                      <Button
                        onClick={() => {
                          pricing.open({
                            features: [FEATURES.SEGMENTS],
                          })
                        }}
                        variant="plain"
                      >
                        {t('DefaultText.upgradeText')}
                      </Button>
                    ),
                  })}
                </p>
              </BlockStack>
            </Banner>
          )}
          <Select
            disabled={!featureEnabled}
            {...form.fields.segmentation}
            options={Object.values(SEGMENTS)}
          />
        </BlockStack>
      </Card>
  )
}
